import { render, staticRenderFns } from "./index.pug?vue&type=template&id=5ff83ef2&scoped=true&lang=pug&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./index.styl?vue&type=style&index=0&id=5ff83ef2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff83ef2",
  null
  
)

export default component.exports